export enum FireOutbreakReactionEnum {
	POSITIVE = 'AVALIACAO_POSITIVA',
	NEGATIVE = 'AVALIACAO_NEGATIVA',
	IMPOSSIBLE = 'AVALIACAO_IMPOSSIVEL',
}
